/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiUserForOrganizationAdminRequest } from '../../models/api-user-for-organization-admin-request';
import { KeyType } from '../../models/key-type';
import { PostApiUserResponse } from '../../models/post-api-user-response';

export interface CreateApiKeyForOrganizationSitesWithRoles$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
      body: ApiUserForOrganizationAdminRequest
}

export function createApiKeyForOrganizationSitesWithRoles(http: HttpClient, rootUrl: string, params: CreateApiKeyForOrganizationSitesWithRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<PostApiUserResponse>> {
  const rb = new RequestBuilder(rootUrl, createApiKeyForOrganizationSitesWithRoles.PATH, 'post');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PostApiUserResponse>;
    })
  );
}

createApiKeyForOrganizationSitesWithRoles.PATH = '/administration/organizations/{organizationKey}/api-users-keys';
